import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import CustomBtn from '../../../../generic/CustomBtn';
import DownloadZone from '../../../DownloadZone/DownloadZone';
import NftMap from '../../../Map/components/NftMap';
import PrevScreenLocation from './PrevScreenLocation';
import GeoJsonUploader from '../AnotherComponents/GeoJsonUploader';
import MapMini from '../../../Map/components/MapMini/MapMini';

const ProjectLocation = ({ step, nextPage, prevPage, state, setState, setRequestError, setShowModal }) => {
  const defaultCoordinate = {
    region: '',
    regionShortCode: '',
    polygon: [],
    codePlus: null,
    polygonCoordinate: [],
    square: 0,
    cidScreenShot: '',
  };
  const { handleSubmit } = useForm();
  const [showMap, setShowMap] = useState(false);
  const [showPrev, setShowPrev] = useState(true);
  const [coordinate, setCoordinate] = useState(defaultCoordinate);
  const [jsonFile, setJsonFile] = useState();
  const translate = useIntl();
  const clearAll = () => {
    setState({ ...state, ...defaultCoordinate });
    setShowPrev(true);
    setJsonFile();
    setCoordinate(defaultCoordinate);
  };

  const onSubmit = () => {
    setRequestError(false);
    setShowModal(false);
    setState({ ...state, ...coordinate });
    nextPage();
  };

  const handleBadIpfs = () => {
    setRequestError(true);
    setShowModal(true);
  };

  if (step !== 1) {
    return null;
  }

  return (
    <div className="wizard__wrapper-form">
      {showMap && (
        <NftMap
          state={coordinate}
          setState={setCoordinate}
          uploadedFile={jsonFile}
          setUploadedFile={setJsonFile}
          setShow={setShowMap}
          setShowPrev={setShowPrev}
          handleBadIpfs={handleBadIpfs}
        />
      )}
      {showPrev && (
        <PrevScreenLocation
          jsonFile={jsonFile}
          setJsonFile={setJsonFile}
          translate={translate}
          setShowMap={setShowMap}
          prevPage={prevPage}
          setShowPrev={setShowPrev}
        />
      )}
      {!showPrev && (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="wizard__coord-big">
          <MapMini
            state={coordinate}
            // uploadedFile={jsonFile}
            // setUploadedFile={setJsonFile}
          />
          <div className="wizard__wrapper-input">
            <div className="wizard__btn-map">
              <div className="wizard__location-option-first">
                <CustomBtn
                  label={translate.formatMessage({ id: 'button-drawZone' })}
                  handleClick={() => setShowMap(true)}
                  iconClass="icon-marker"
                  customClass="btn__map"
                />
              </div>
              {coordinate?.geoFile ? (
                <p className="wizard__geojson-filename">
                  {coordinate?.geoFile}
                </p>
              ) : (
                <div className="wizard__location-option-uploader">
                  <GeoJsonUploader
                    jsonFile={jsonFile}
                    setJsonFile={setJsonFile}
                    setShowMap={setShowMap}
                  />
                </div>
              )}
              <div className="wizard__location-option-reset">
                <CustomBtn
                  label={translate.formatMessage({ id: 'button-reset' })}
                  handleClick={clearAll}
                  iconClass="icon-reload-circle"
                  customClass="btn__reset"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="wizard__coord">
          <span className="wizard__label">
            {translate.formatMessage({ id: 'wizardForm.step2.location' })}
          </span>
          <p className="wizard__code-plus wizard__region">
            {coordinate.region}
          </p>
        </div>
        <div className="wizard__coord">
          <span className="wizard__label">
            {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
          </span>
          <p className="wizard__code-plus">
            {coordinate.codePlus}
          </p>
        </div>
        <div className="wizard__coord">
          <span className="wizard__label">
            *
            {translate.formatMessage({ id: 'wizardForm.step3.projectArea' })}
          </span>
          <p className="wizard__code-plus wizard__area">
            <NumberFormat
              value={coordinate.square}
              displayType="text"
              thousandSeparator
            />
          </p>
        </div>
        <div className="wizard__coord">
          <DownloadZone
            customClass="btn__download-zone-init"
            showPosition="top"
            fileName={`ofp_${state.name}_nftZone`}
            coordinate={coordinate}
            buttonText={translate.formatMessage({ id: 'download.zone' })}
          />
        </div>
        <div className="wizard__wrapper-panel">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            handleClick={() => prevPage()}
            type="button"
            customClass="btn__cancel"
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-next' })}
            handleClick={() => {}}
            type="submit"
          />
        </div>
      </form>
      )}
    </div>

  );
};

export default ProjectLocation;
